import React from 'react';
import {t} from '@lingui/core/macro';

import Table, {IColumn} from 'shared/ui/Table/Table';
import IncidentStatus from 'shared/ui/Status/IncidentStatus';
import IncidentStatusBadge from 'shared/ui/Status/IncidentStatusBadge';
import {getFormattedDate} from 'shared/lib/datetime';
import {isTranslate} from 'shared/lib/lang';

import {IStatusPageIncident} from '../../../model/IStatusPageView';

import styles from './StatusIncidents.module.scss';

interface IStatusIncidentsProps {
    incidents: IStatusPageIncident[],
}

const MAX_INCIDENTS = 5;
const dateFormat = !isTranslate() ? 'DD.MM.YYYY, HH:mm' : 'YYYY-MM-DD, HH:mm';

const rowFactory = (incident: IStatusPageIncident) => (
    <tr key={incident.created_at}>
        <td>
            <div className={styles.statusCell}>
                <IncidentStatus resolved={incident.resolved}/>
                <IncidentStatusBadge resolved={incident.resolved}/>
            </div>
        </td>
        <td className={styles.error}>{incident.error}</td>
        <td className={styles.nowrap}>{getFormattedDate(incident.created_at, {format: dateFormat})}</td>
        <td className={styles.nowrap}>
            {incident.resolved_at ? getFormattedDate(incident.resolved_at, {format: dateFormat}) : '—'}
        </td>
        <td className={styles.nowrap}>{incident.duration_formatted}</td>
    </tr>
);

const StatusIncidents: React.FC<IStatusIncidentsProps> = ({incidents}) => {
    if (!incidents || incidents.length === 0) {
        return null;
    }

    const columns: IColumn[] = [
        {label: t`Статус`},
        {label: t`Ошибка`},
        {label: t`Начало`},
        {label: t`Окончание`},
        {label: t`Длительность`},
    ];

    return (
        <div className={styles.container}>
            <h3 className={styles.title}>{t`Последние инциденты`}</h3>
            <Table
                columns={columns}
                items={incidents.slice(0, MAX_INCIDENTS)}
                rowFactory={rowFactory}
                isLoading={false}
            />
        </div>
    );
};

export default StatusIncidents;
